import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import type { ComponentProps } from 'react';

import { BonusChip } from '@sorare/core/src/components/card/BonusChip';
import { powerWithSkinBonus } from '@sorare/core/src/lib/bonus';

import type { CardBonus_anyCard } from './__generated__/index.graphql.ts';

type Props = {
  card: CardBonus_anyCard;
  withTransferMalus?: boolean;
  size?: ComponentProps<typeof BonusChip>['size'];
};

export const CardBonus = ({ card, withTransferMalus, size }: Props) => {
  return (
    <BonusChip
      bonus={powerWithSkinBonus(card.power, card.skinEdition)}
      skin={card.skinEdition?.skin}
      powerBreakdown={card.powerBreakdown}
      withTransferMalus={withTransferMalus}
      transferMalus={
        withTransferMalus ? Number(card.powerMalusAfterTransfer) : 0
      }
      size={size}
    />
  );
};

CardBonus.fragments = {
  anyCard: gql`
    fragment CardBonus_anyCard on AnyCardInterface {
      slug
      power
      powerMalusAfterTransfer
      skinEdition {
        bonus
        skin
      }
      powerBreakdown {
        ...BonusChip_powerBreakdown
      }
    }
    ${BonusChip.fragments.powerBreakdown}
  ` as TypedDocumentNode<CardBonus_anyCard>,
};
